import { PartnersClient } from "./partners.js";
import { ClientBase } from "./base.js";
export class InventoryClient extends PartnersClient {
    /** GET /v1/sites/{slug}/inventory. */
    async listInventory(slug) {
        return this.request("GET", `${this.siteBase(slug)}/inventory`, undefined, true);
    }
    /** PUT /v1/sites/{slug}/inventory/{itemId}. */
    async putInventory(slug, itemId, body) {
        return this.request("PUT", `${this.siteBase(slug)}/inventory/${encodeURIComponent(itemId)}`, body, true);
    }
    async listVendors(slug) {
        const res = await this.request("GET", `${this.siteBase(slug)}/vendors`, undefined, true);
        return res.vendors;
    }
    async createVendor(slug, input) {
        return this.request("POST", `${this.siteBase(slug)}/vendors`, input, true);
    }
    async mapVendorItem(slug, vendorId, input) {
        return this.request("POST", `${this.siteBase(slug)}/vendors/${encodeURIComponent(vendorId)}/items`, input, true);
    }
    /** GET /v1/sites/{slug}/purchase-orders. */
    async listPurchaseOrders(slug) {
        return this.request("GET", `${this.siteBase(slug)}/purchase-orders`, undefined, true);
    }
    /** POST /v1/sites/{slug}/purchase-orders/from-low-stock (draft suggestions). */
    async suggestFromLowStock(slug) {
        return this.request("POST", `${this.siteBase(slug)}/purchase-orders/from-low-stock`, undefined, true);
    }
    async sendPurchaseOrder(slug, id) {
        return this.request("POST", `${this.siteBase(slug)}/purchase-orders/${encodeURIComponent(id)}/send`, undefined, true);
    }
    // Lots (#782)
    async receiveLot(slug, input) {
        return this.request("POST", `${this.siteBase(slug)}/inventory/lots`, input, true);
    }
    async listLots(slug, productRef) {
        const res = await this.request("GET", `${this.siteBase(slug)}/inventory/lots${ClientBase.query({ productRef })}`, undefined, true);
        return res.lots;
    }
    async setLotQuarantine(slug, lotId, quarantined) {
        return this.request("POST", `${this.siteBase(slug)}/inventory/lots/${encodeURIComponent(lotId)}/quarantine`, { quarantined }, true);
    }
    async listLotMovements(slug, lotId) {
        const res = await this.request("GET", `${this.siteBase(slug)}/inventory/lots/${encodeURIComponent(lotId)}/movements`, undefined, true);
        return res.movements;
    }
    /** FEFO preview; never picks expired lots. */
    async pickLots(slug, productRef, qty) {
        const res = await this.request("GET", `${this.siteBase(slug)}/inventory/lots/pick${ClientBase.query({ productRef, qty })}`, undefined, true);
        return res.allocations;
    }
    /** BOM decrement, all or nothing. */
    async allocateLots(slug, input) {
        const res = await this.request("POST", `${this.siteBase(slug)}/inventory/lots/allocate`, input, true);
        return res.allocations;
    }
    async listLotAlerts(slug) {
        const res = await this.request("GET", `${this.siteBase(slug)}/inventory/lot-alerts`, undefined, true);
        return res.alerts;
    }
    /** Returns only alerts raised by this call (safe to schedule). */
    async scanLotAlerts(slug) {
        const res = await this.request("POST", `${this.siteBase(slug)}/inventory/lot-alerts/scan`, undefined, true);
        return res.alerts;
    }
    async getLotAlertThresholds(slug) {
        const res = await this.request("GET", `${this.siteBase(slug)}/inventory/lot-alert-thresholds`, undefined, true);
        return res.days;
    }
    async putLotAlertThresholds(slug, days) {
        const res = await this.request("PUT", `${this.siteBase(slug)}/inventory/lot-alert-thresholds`, { days }, true);
        return res.days;
    }
}
//# sourceMappingURL=inventory.js.map